import * as actionTypes from '../actions/actionTypes';

const intiData = {
  cancelBtn: {
    disabled: false
  },
  sendToClientBtn: {
    disabled: false
  },
  previewRequestBtn: {
    disabled: false
  },
  generateDocumentationBtn: {
    disabled: true
  },
  shareCase: {
    disabled: false
  },
  submitRequest: {
    disabled: true
  },
  addOwner:{
  disabled: false
  },
  showPreviewAndGenerateDocBtns: true
};

export default function caseBodyFooterReducer(state = intiData, action) {
  switch(action.type) {
    case actionTypes.ENABLE_CASE_BODY_FOOTER_BTN: {
      let _newState = {...state};
      _newState[action.btnName] = {disabled: false};
      return _newState;
    }
    case actionTypes.DISABLE_CASE_BODY_FOOTER_BTN: {
      let _newState = {...state};
      _newState[action.btnName] = {disabled: true};
      return _newState;
    }
    case actionTypes.ENABLE_ALL_CASE_BODY_FOOTER_BTNS: {
      let _newState = {...state};
      _newState[action.btnName] = {
        cancelBtn: {
          disabled: false
        },
        sendToClientBtn: {
          disabled: false
        },
        previewRequestBtn: {
          disabled: false
        },
        generateDocumentationBtn: {
          disabled: true
        },
        shareCase: {
          disabled: false
        },
        submitRequest: {
          disabled: true
        },
        addOwner:{
          disabled: false
        }
      };
      return _newState;
    }
    case actionTypes.DISABLE_ALL_CASE_BODY_FOOTER_BTNS: {
      let _newState = {...state};
      _newState = {
          cancelBtn: {
            disabled: true
          },
          sendToClientBtn: {
            disabled: true
          },
          previewRequestBtn: {
            disabled: true
          },
          generateDocumentationBtn: {
            disabled: true
          },
          shareCase: {
            disabled: true
          },
          submitRequest: {
            disabled: true
          },
          addOwner:{
            disabled: true
          },
        showPreviewAndGenerateDocBtns : true
        };
      return _newState;
    }
    case actionTypes.SHOW_PREVIEW_AND_GENERATEDOC_BTNS: {
      let _newState = {...state};
      _newState.showPreviewAndGenerateDocBtns = true;
      return _newState;
    }
    case actionTypes.HIDE_PREVIEW_AND_GENERATEDOC_BTNS: {
      let _newState = {...state};
      _newState.showPreviewAndGenerateDocBtns = false;
      return _newState;
    }
    case actionTypes.ENABLE_CASE_BODY_FOOTER_SUBMIT_BTN: {
      let _newState = {...state};
      _newState[action.btnName] = {disabled: false};
      return _newState;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/caseBodyFooterReducer.js